import React, {Component, Fragment} from 'react';

import {Button, Form, InputGroup, InputGroupAddon, Input, FormGroup, Label, Tooltip} from 'reactstrap';
import axios from "axios";
import Swal from 'sweetalert2';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import LangContext from "../providers/LangContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/pro-light-svg-icons/faInfoCircle";

const toast = Swal.mixin({
	toast: true,
	position: 'top',
	showConfirmButton: false,
	timer: 5000,
});

class Protected extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleTerms = this.toggleTerms.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);

        this.state = {
            password: "",
            showTerms: false,
            termsAgreed: true,
            showTooltip: false,
        };

        const csrf = document.head.querySelector('meta[name="csrf-token"]');

        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
        axios.defaults.headers.common["X-CSRF-TOKEN"] = csrf.content;
        axios.defaults.headers.common["X-localization"] = document.documentElement.lang;
    }

    componentDidMount() {
        const companyID = document.head.querySelector('meta[name="company_id"]').content;
        const companiesWithTerms = [];
        if(false === this.state.showTerms && companiesWithTerms.findIndex((element) => element == companyID) >= 0) {
            this.setState({showTerms: true, termsAgreed: false});
        }
    }

    toggleTerms() {
        this.setState({termsAgreed: !this.state.termsAgreed});
    }

    toggleTooltip() {
        this.setState({showTooltip: !this.state.showTooltip});
    }

    submit(event) {
        let self = this;
        event.preventDefault();

        axios
            .post("/api/site/" + this.props.siteID + "/restricted-docs", {
                password: this.state.password
            })
            .then(response => {
                toast.fire({
                    icon: "success",
                    title: this.context.lang.get("sites.password_valid")
                });
                this.props.getSitePages();
            })
            .catch(error => {
                toast.fire({
                    icon: "error",
                    title: this.context.lang.get("sites.password_invalid")
                });
            });
    }

    handleChange(e) {
        this.setState({ password: e.target.value });
    }

    render() {
        const placement = (window.innerWidth > 992) ? 'right' : 'bottom';
        return (
            <Fragment>
                <h3 className="text-uppercase">
                    {this.context.lang.get(
                        "sites.documentation_restricted_title"
                    )}
                </h3>
                <p dangerouslySetInnerHTML={{__html: this.context.lang.get(
                        "sites.documentation_restricted_text",{email: this.props.customerEmail, phone: this.props.customerPhone}
                    )}} />

                <Form className="row mt-2" onSubmit={this.submit}>
                    <InputGroup className={"col-12 col-md-7"}>
                        <Input
                            type="password"
                            name="password"
                            id="password"
                            placeholder={this.context.lang.get(
                                "sites.password"
                            )}
                            onChange={this.handleChange}
                        />
                        <InputGroupAddon addonType="append">
                            <Button className="btn btn-primary" type="submit" disabled={!this.state.termsAgreed}>
                                {this.context.lang.get(
                                    "sites.documentation_confirm"
                                )}
                            </Button>
                        </InputGroupAddon>
                    </InputGroup>
                    {this.state.showTerms &&
                        <div className="col-12 mt-3 terms-check-container">
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" onChange={this.toggleTerms} /> <span>Hierbij verklaar ik mij bekend en akkoord met de <span
                                    id="termsCheck">voorwaarden <FontAwesomeIcon icon={faInfoCircle}/></span></span>
                                </Label>
                            </FormGroup>
                            <Tooltip placement={placement} isOpen={this.state.showTooltip} target="termsCheck" toggle={this.toggleTooltip} innerClassName={'large-tooltip'}>
                                Dit portal bevat privacygevoelige en vertrouwelijke informatie en is uitsluitend bestemd voor de rechtmatige gebruiker aan wie het wachtwoord is vertrekt. Openbaarmaking, vermenigvuldiging, verspreiding en/ of verstrekking van deze informatie aan derden is, behoudens voorafgaande schriftelijke toestemming van Punt Makelaars B.V., niet toegestaan.
                            </Tooltip>
                        </div>
                    }
                </Form>
            </Fragment>
        );
    }
}

export default HeaderFooterHOC(Protected);
